import { render, staticRenderFns } from "./MigrationAlertComponent.vue?vue&type=template&id=42bb888f&"
import script from "./MigrationAlertComponent.vue?vue&type=script&lang=js&"
export * from "./MigrationAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VLayout})
